const user = {
  state: {
    userObj: null
  },
  actions: {
    setUser: function (context, {userObj}) {
      context.state.userObj = userObj
    }
  }
}

export default user
